import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { firstName } from './common-steps'
import { lastNameTicket, thanksTicket, ticketInitialInfo, emailAddressTicket, commmentTicket } from './ticket-steps'

export const ticketScenarioA: Scenario = {
  id: 'ticket-a',
  initialStep: Steps.TICKET_INITIAL_INFO,
  type: ScenarioType.TICKET,
  version: '1',
  milestones: [
    ticketInitialInfo.id,
    firstName.id,
    lastNameTicket.id,
    emailAddressTicket.id,
    commmentTicket.id,
    thanksTicket.id,
  ],
  steps: [ticketInitialInfo, firstName, lastNameTicket, emailAddressTicket, commmentTicket, thanksTicket],
  weight: 1,
}
